// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Suitcase from '../_raw/ui/icon_suitcase.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Suitcase);
